import { listingQueryKeys as e } from "./useListingSearchQuery.mjs";
import { useInfiniteQuery as t } from "@maat/store-hooks";
import { listingsApi as n } from "@maat/api-main";
import { addMonths as r, endOfMonth as i, format as a, startOfMonth as o, today as s } from "@maat/datetime";
//#region src/listings/useListingCalendarQuery.ts
var c = 3, l = (e) => a(e, "yyyy-MM-dd"), u = (a) => t({
	queryKey: e.calendar(a),
	queryFn: ({ pageParam: e }) => {
		let t = s(), u = o(r(t, e * c)), d = i(r(t, (e + 1) * c - 1));
		return n.getListingCalendar(a, {
			start_date: l(u),
			end_date: l(d)
		});
	},
	enabled: !!a,
	initialPageParam: 0,
	getNextPageParam: (e, t, n) => n + 1,
	staleTime: 300 * 1e3
});
//#endregion
export { u as useListingCalendarQuery };
